/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import {
  getTopPanelVerbId,
  getTopPanelVisibility,
  getTopPanelOptions,
  getTopPanelExpandedState
} from "../../selectors/topPanelSelectors";
import TopPanelView from "components/topPanel/TopPanel";
import { getBottomPanelHeight } from "../../selectors/documentSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  ...ownProps,
  topPanelVerbId: getTopPanelVerbId(stores),
  topPanelVisibility: getTopPanelVisibility(stores),
  bottomOffset: getBottomPanelHeight(stores),
  topPanelOptions: getTopPanelOptions(stores),
  setFabVisibility: stores.FABStore.setFABVisibility,
  setTopPanelVisibility: stores.topPanelStore.setTopPanelVisibility,
  setTopPanelExpandedState: stores.topPanelStore.setTopPanelExpandedState,
  isTopPanelExpaned: getTopPanelExpandedState(stores)
});

const TopPanelContainer = inject(mapStoreToProps)(TopPanelView);

export default TopPanelContainer;
